const capitalize = (str) => {
  if(!str) {
    return "";
  }

  if(!str.split) {
    return "";
  }

  const words = str?.split(" ");
  return words?.map((word) => { 
      const low = word.toLowerCase();
      return low[0].toUpperCase() + low.substring(1); 
  }).join(" ").trim();
};

export { capitalize };